export const PATH_NAMES = Object.freeze({
  SELECT_ADDRESS: 'shops',
  SELECT_DATE: 'select-date',
  ABOUT_YOU: 'about-you',
  REVIEW: 'review',
  BOOKING: 'bookings/:bookingId',
  COMPLETED_BOOKING: 'completed-booking',

  EDIT_ADDRESS: 'edit-shop',
  EDIT_DATE: 'edit-date',
  EDIT_YOUR_DETAILS: 'edit-your-details',
  EDIT_QUESTION_ANSWERS: 'edit-question-answers',
});
